function skipLinks() {
  if (document.querySelector('#page')) {
    document.querySelector('#page').tabIndex = -1;
  }
}

export { skipLinks };